import React from 'react';
import { useFormContext } from '../Provider';
import CommonFieldWrapper from './CommonFieldWrapper';
import Toggle from '../../Button/Toggle';
import Help from './Fragments/Help';

const fallbackValue = {};

const SwitchGroup = ({label, switches, name, help, onChange, disabled, validators}) => {
    const { formData, updateField, isValidating, isSubmitting, formDisabled } = useFormContext();
    let value = formData[name] ?? fallbackValue;
    const isDisabled = formDisabled || disabled || isSubmitting;

    const handleChange = (switchName, state) => {
        if (name) {
            const newVal = {...value, [switchName]: state};
            updateField(name, newVal);
            onChange && onChange(newVal);
        } else {
            updateField(switchName, state);
            onChange && onChange(state);
        }
    }

    return <CommonFieldWrapper {...{label, help, isValidating, validators, isDisabled}}>

        {switches.map((sw) => {
            return <Switch key={sw.name}
                {...{
                label: sw.label,
                name: sw.name,
                help: sw.help,
                onChange: sw.onChange,
                formData: name ? formData[name] ?? {} : formData,
                disabled: sw.disabled || isDisabled,
                ...{updateField, handleChange}
            }} />
        })}
    </CommonFieldWrapper>
}

const Switch = ({label, name, handleChange, onChange, innerLabel, disabled, formData, help}) => {
    const value = formData[name] ?? '';

    return <>
        <Toggle
            enabled={value}
            onChange={(v) => {
                handleChange(name, v);
                onChange && onChange(v);
            }}
            label={innerLabel ?? label}
            disabled={disabled}
            className="my-3"
            hideFocusRing
        />
        {help && <Help help={help} value={value} />}
    </>
}

export default SwitchGroup;
